import { AdvancedTagMapping } from 'src/features/gateway-details/types';
import { ModalTableRowData, UserDefinedValue } from '../types';

export function getFormattedData(
  data: AdvancedTagMapping,
  rowData: ModalTableRowData[],
  gatewayId: string,
  tagId: string,
  dataType?: string
): any[] {
  const userDefinedValues: UserDefinedValue[] = [];
  const validProperties: string[][] = [];

  rowData.forEach((row) => {
    validProperties.push([`value-${row.index}`, `category-${row.index}`, `name-${row.index}`]);
  });

  Object.keys(data).forEach((key) => {
    const arr = validProperties.find((subArr) => subArr.includes(key));
    if (arr) {
      const index = +arr[0].split('-')[1];
      const tempObj: UserDefinedValue = {
        value: +data[arr[0]],
        category: data[arr[1]] === '' ? null : (data[arr[1]] as string),
        name: data[arr[2]] as string,
        index: index,
        tagId: tagId,
        gatewayId: gatewayId,
      };

      if (dataType === 'BOOLEAN') {
        tempObj.valueFlag = index === 0 ? false : true;
      }

      userDefinedValues.push(tempObj);

      validProperties.splice(validProperties.indexOf(arr), 1);
    }
  });

  return userDefinedValues;
}
